module.exports = __webpack_public_path__ + "24e004ab/img/comment-question-icon.7dd26e04.svg";